/**
 * This is a generic component that will render a timeline row without a fixed
 * prop structure, aside from its icon and icon color. Instead it prioritises
 * rendering its children as the main body of the timeline row. Rendering the
 * 'connector' line is based on a prop flag instead of calculating based on
 * index and total timeline count props (as in ./LogTimelineRow).
 */
// @ts-nocheck

import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import { css, StyleSheet } from 'aphrodite/no-important'

const TimelineRow = ({
  children,
  icon: { color = colors.darkblue, url },
  showConnector,
  style,
  ...props
}) => (
  <div
    className={css(classes.wrapper)}
    style={style}
    data-testid={props['data-testid']}
  >
    <div className={css(classes.leftContainer)}>
      <div
        className={css(classes.iconContainer)}
        style={{ backgroundColor: color }}
      >
        <img alt="" className={css(classes.icon)} src={url} />
      </div>
      {showConnector && <div className={css(classes.connector)} />}
    </div>
    {children}
  </div>
)

const classes = StyleSheet.create({
  connector: {
    background: colors.grey,
    flex: 1,
    minHeight: 10,
    width: 4,
  },
  icon: {
    width: 18,
  },
  iconContainer: {
    alignItems: 'center',
    borderRadius: 44,
    display: 'flex',
    justifyContent: 'center',
    height: 44,
    width: 44,
  },
  leftContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    marginRight: 15,
    paddingTop: 5,
  },
  wrapper: {
    display: 'flex',
    marginBottom: '-5px',
  },
})

TimelineRow.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.shape({
    color: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  showConnector: PropTypes.bool,
  style: PropTypes.object,
}

export default TimelineRow
